import { defineMessages } from "react-intl";

const USER_IMAGE = "user-image";

const userInfoImageMessages = defineMessages({
  profileAltText: {
    id: `${USER_IMAGE}.alt-text`,
    defaultMessage: "user profile"
  }
});

export default userInfoImageMessages;
